import { createElementBlock as t, openBlock as r, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), t("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M11.303 3c1.517 0 2.813.394 3.876 1.066v4.718c-1.068-.775-2.429-1.205-3.495-1.205-2.894 0-5.021 2.134-5.021 4.867 0 2.721 2.127 4.868 5.021 4.868 1.066 0 2.428-.443 3.495-1.218v4.731c-1.063.675-2.36 1.054-3.876 1.054C6.16 21.881 2 17.668 2 12.446 2 7.23 6.16 3 11.303 3m4.8 1.562c2.04 1.342 4.98 5.528 5.769 7.84-.764 2.243-3.542 6.227-5.57 7.7l-.2.14z"
    }, null, -1)
  ]));
}
const d = { render: l };
export {
  d as default,
  l as render
};
//# sourceMappingURL=ic_brand_smart-DYyc9ghH.js.map
